import React from "react";
import { capitalized1LetterS, teamLeagueInfoUrl } from "../../utils/generalLiveCenter";

const MatchDetailTabs = ({
  tabs,
  id,
  sport = "football",
  dictionary,
  currentTab,
  websiteBaseUrl,
  dataPath,
  name,
}) => {

  return (
    <nav className="detail_main_tab">
      <ul>
        {tabs?.map((tab) => {
          const isActive =
            tab === currentTab ||
            (tab === "stats" && currentTab === "season-stats");

          return (
            <li key={tab} type={tab}>
              <a
                className={isActive ? "active" : ""}

                href={teamLeagueInfoUrl({
                  dataClient: true,
                  websiteBaseUrl,
                  dataPath,
                  category: "match-detail",
                  sport,
                  name: name,
                  id: id,
                  tab: tab?.replaceAll("_", "-")
                })}
              >

                {tab === "h2h"
                  ? "H2H"
                  : dictionary?.[tab.replaceAll("_", "")] ||
                  capitalized1LetterS(tab)}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MatchDetailTabs;
